import * as React from "react";
import { FormattedMessage, injectIntl, WrappedComponentProps } from "react-intl";
import { Props as FormattedMessageProps } from "react-intl/dist/components/message";
import { GetTranslation } from "../../translations/GetTranslation";
import { TranslationKey } from "../../translations/TranslationKey";

type TranslatedMessageProps = {
  id: TranslationKey;
} & FormattedMessageProps &
  WrappedComponentProps;

const TranslatedMessage: React.FunctionComponent<TranslatedMessageProps> = ({ id, intl, values }) => {
  if (!id) {
    console.warn("TranslatedMessage: invalid 'id' parameter.");
    return null;
  }
  const containsSeveralKeys = id.indexOf("{") >= 0;
  if (containsSeveralKeys) {
    const translatedText = GetTranslation(intl, id);
    return <span>{translatedText}</span>;
  }

  return <FormattedMessage id={id} values={values} />;
};

export default injectIntl(TranslatedMessage);
